
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"72","height":"144"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M61 144H11c-5.5 0-10-4.5-10-10V10C1 4.5 5.5 0 11 0h50c5.5 0 10 4.5 10 10v124c0 5.5-4.5 10-10 10zM11 2c-4.4 0-8 3.6-8 8v124c0 4.4 3.6 8 8 8h50c4.4 0 8-3.6 8-8V10c0-4.4-3.6-8-8-8H11zM0 17h1v6H0zM0 28h1v9H0zM0 40h1v9H0z"}}),_c('path',{attrs:{"d":"M32 10h8c.6 0 1 .4 1 1s-.4 1-1 1h-8c-.6 0-1-.4-1-1s.4-1 1-1zM26 10c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zM35.5 8c-.8 0-1.5-.7-1.5-1.5S34.7 5 35.5 5s1.5.7 1.5 1.5S36.3 8 35.5 8zm0-2c-.3 0-.5.2-.5.5s.2.5.5.5.5-.2.5-.5-.2-.5-.5-.5zM36 139c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"}}),_c('g',[_c('path',{attrs:{"d":"M6 17h60v108H6z","opacity":".1"}}),_c('path',{attrs:{"d":"M67 126H5V16h62v110zm-60-2h58V18H7v106z"}})]),_c('g',[_c('path',{attrs:{"d":"M71 28h1v9h-1z"}})])])
          )
        }
      }
    